export default function safe(value) {
    if (!value) return "---"
    return value
}
